let siteName = 'Mousa Alsheikh';

export const config = {
  apiUrl: 'YOUR API URL',
  googleAnalyticsId: 'UA-999999-9',
  meta: {
    siteName: `${siteName}`,
    keywords: `${siteName}`,
    description: `${siteName}`,
    og_title: `${siteName}`,
    og_description: `${siteName}`,
    og_image: 'assets/images/og-image.jpg',
    og_site_name: `${siteName}`,
    og_type: 'Website',
    siteUrl: 'http://www.mousa-alsheikh.com'
  }
};
